import { COLORS } from '@btime/constants'
import { ControlledListHandler, useControlledList, useControlledListActions } from '@btime/react-contexts'
import { useEffectAfterMount } from '@btime/react-hooks'
import React from 'react'

import FlexGrid, { FlexCol } from '../structure/FlexGrid'
import Icon from '../shapes/Icon'
import IconText from '../presentation/IconText'
import Input from './Input'
import Link from '../actions/Link'
import Separator from '../helpers/Separator'

const KeyValueInput = ({ onChange, keyPlaceholder, valuePlaceholder }) => {
  const values = useControlledList()
  const { addNew, handleChangeItemValue, removeItem } = useControlledListActions()

  useEffectAfterMount(() => {
    onChange(values)
  }, [values])

  return (
    <>
      {values.map((item, index) => (
        <FlexGrid paddingGutter={0.5} align="center" justify="center" direction="row" key={index}>
          <FlexCol flex={2}>
            <Input onStopTyping={handleChangeItemValue(index, 'key')} value={item.key} placeholder={keyPlaceholder} />
          </FlexCol>
          <FlexCol flex={5}>
            <Input
              onStopTyping={handleChangeItemValue(index, 'value')}
              value={item.value}
              placeholder={valuePlaceholder}
            />
          </FlexCol>
          <FlexCol>
            <Icon name="BsTrash" onClick={() => removeItem(index)} size="1rem" color={COLORS.red} />
          </FlexCol>
        </FlexGrid>
      ))}
      <Separator weight={4} />
      <Link block onClick={addNew}>
        <IconText left iconName="BsPlusCircle" label={'Add novo'} color={COLORS.purple} />
      </Link>
    </>
  )
}

const Wrapper = ({ value, ...props }) => (
  <ControlledListHandler initialState={value || []}>
    <KeyValueInput {...props} />
  </ControlledListHandler>
)

export default Wrapper
